import React, { Fragment } from 'react';
export function GenerationalSection() {
  const generations = [{
    emoji: '👴',
    name: 'Bisabuelo',
    description: 'Un evento doloroso ocurrió… pero no pudo ser sanado.',
    active: false
  }, {
    emoji: '👨‍🦳',
    name: 'Abuelo',
    description: 'Ese dolor no desapareció… se silenció.',
    active: false
  }, {
    emoji: '👨',
    name: 'Padres',
    description: 'Se transformó en emociones, creencias o patrones.',
    active: false
  }, {
    emoji: '🧍',
    name: 'Tú',
    description: 'Hoy lo vives como si fuera tuyo… sin saberlo.',
    active: true
  }];
  return <section className="w-full py-20 md:py-28 px-6 bg-beige" data-id="element-71">
      <div className="max-w-6xl mx-auto text-center" data-id="element-72">
        <h2 className="font-playfair text-4xl md:text-5xl text-dark mb-14" data-id="element-73">
          Esto no empezó contigo
        </h2>

        <div className="flex flex-col md:flex-row items-center md:items-start justify-center gap-4 md:gap-0 relative" data-id="element-74">
          {generations.map((gen, index) => <Fragment key={index} data-id="element-75">
              <div className="flex flex-col items-center z-10 w-full md:w-64 px-4" data-id="element-76">
                <div className={`w-20 h-20 md:w-24 md:h-24 rounded-full flex items-center justify-center bg-white shadow-lg transition-all duration-500 mb-6
                    ${gen.active ? 'border-4 border-terracotta shadow-terracotta/30 scale-110' : 'border border-dark/10'}
                  `} data-id="element-77">
                  <span className="text-3xl md:text-4xl" data-id="element-78">{gen.emoji}</span>
                </div>
                <h3 className={`font-playfair text-xl md:text-2xl mb-3 ${gen.active ? 'text-terracotta font-bold' : 'text-dark font-medium'}`} data-id="element-79">
                  {gen.name}
                </h3>
                <p className={`text-sm md:text-base leading-relaxed text-center ${gen.active ? 'text-dark font-medium' : 'text-dark/70 font-light'}`} data-id="element-80">
                  {gen.description}
                </p>
              </div>

              {/* Connector Line */}
              {index < generations.length - 1 && <div className="w-px h-12 md:w-16 md:h-px bg-dark/20 md:mt-12 shrink-0" data-id="element-81"></div>}
            </Fragment>)}
        </div>

        <p className="font-playfair italic text-dark/60 text-xl md:text-2xl text-center mt-12 md:mt-16" data-id="element-82">
          "Y lo llamas 'mi forma de ser'…"
        </p>
      </div>
    </section>;
}